export default "__VITE_ASSET__D0kPC0l3__"